import { useEffect, useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import MUITable from '../../Common/MUITable';
import AddEditDriverTsMap from './AddEditDriverTsMap';
import Loader from '../../Common/Loader/loader';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import isGHMC from '../../Common/helper/helpar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllDriverTSMapping, GetDrivers, GetTransferStations } from '../Attendance/AttendanceApis';

const toArray = (value) => {
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.data)) return value.data;
    return [];
};

const DriverTSMap = () => {
    const isProd = isGHMC();
    const [ShowModal, setShowModal] = useState(false);
    const [editRow, setEditRow] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [drivers, setDrivers] = useState([]);
    const [transferStations, setTransferStations] = useState([]);
    const [driverTSMaps, setDriverTSMaps] = useState([]);
    const [driverNameFilter, setDriverNameFilter] = useState('');
    const [isOptionsLoading, setIsOptionsLoading] = useState(false);

    let storedPermissions = localStorage.getItem("permissionId");
    const permissionValues1 =
        JSON.parse(localStorage.getItem("rolePermissions")) || [];
    let canWriteValue = true;

    storedPermissions = parseInt(storedPermissions, 10);

    const matchingPermission = Array.isArray(permissionValues1)
        ? permissionValues1.find((mapping) => mapping.permissionId === storedPermissions)
        : null;

    if (matchingPermission) {
        canWriteValue = matchingPermission.canWrite;
    }

    const getDriversData = async () => {
        try {
            const driverResponse = await GetDrivers();
            setDrivers(toArray(driverResponse));
        } catch (error) {
            console.error("Error fetching driver data:", error);
            setDrivers([]);
        }
    };

    const getTransferStationsData = async () => {
        try {
            const tsResponse = await GetTransferStations();
            setTransferStations(toArray(tsResponse));
        } catch (error) {
            console.error("Error fetching transfer station data:", error);
            setTransferStations([]);
        }
    };

    const getDriverTSMapData = async () => {
        setIsOptionsLoading(true);
        try {
            const response = await getAllDriverTSMapping();
            setDriverTSMaps(toArray(response));
        } catch (error) {
            console.error("Error fetching driver TS map data:", error);
            setDriverTSMaps([]);
        } finally {
            setIsOptionsLoading(false);
        }
    };

    useEffect(() => {
        const loadPageData = async () => {
            setIsOptionsLoading(true);
            await Promise.all([getDriversData(), getTransferStationsData()]);
            await getDriverTSMapData();
        };
        loadPageData();
    }, []);

    const handleAdd = () => {
        setIsEditMode(false);
        setEditRow(null);
        setShowModal(true);
    };

    const handleEdit = (row) => {
        setShowModal(true);
        setIsEditMode(true);
        setEditRow(row);
    };

    const driverTSMapColumns = [
        {
            label: "Driver",
            render: (row) => row.driverName || "N/A",
        },
        {
            label: "Transfer Station",
            render: (row) => row.transferStationName || row.tsName || "N/A",
        },
        {
            label: "Status",
            render: (row) => row.isActive ? "Active" : "InActive",
        },
        {
            label: "Action",
            render: (row) => (
                <button
                    className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
                    onClick={() => handleEdit(row)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            ),
        },
    ];

    const filteredRows = driverTSMaps.filter((row) => {
        if (!driverNameFilter.trim()) return true;
        const rowDriverName = row?.driverName ?? row?.DriverName ?? "";
        return rowDriverName.toLowerCase().includes(driverNameFilter.trim().toLowerCase());
    });

    return (
        <>
            {isOptionsLoading && <Loader />}
            <div className="content text-start">
                <div className="page-content">
                    <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                        <div className="col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                style={{ backgroundColor: '#fff' }}
                                placeholder="Enter Driver Name"
                                value={driverNameFilter}
                                onChange={(e) => setDriverNameFilter(e.target.value)}
                            />
                        </div>
                        <div>
                            {canWriteValue ? (
                                <button className="button-container" onClick={handleAdd}>
                                    <FaPlus className='font-size-20 me-1' /> Add Driver TS Map
                                </button>
                            ) : ""}
                        </div>
                    </div>
                    <div className="card shadow mt-3">
                        <div className="card-body">
                            <div>
                                <div className="top-header text-center">
                                    <span>Driver TS Map Details</span>
                                </div>
                                <MUITable
                                    needSRNumber={true}
                                    rows={filteredRows}
                                    columns={driverTSMapColumns}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddEditDriverTsMap
                showModal={ShowModal}
                setShowModal={setShowModal}
                editRow={editRow}
                isEditMode={isEditMode}
                driverData={drivers}
                tsData={transferStations}
                getDriverTSMapData={getDriverTSMapData}
            />
        </>
    );
};

export default DriverTSMap;
